import once from 'lodash/once';

import { REPORT_EVENTS, BI_EVENTS } from '../../constants';
import { biLogger } from '../../services/biLogger';
import { httpClient, httpClientHeader } from '../../services/httpClient';
import { reportEvent } from '../reportEvent';
import arrayToQueryString from '../../utils/arrayToQueryString';

const API_URL = '/_api/wix-new-releases-service/v1/announcements/count';

const sendNotificationShownBI = once((count, metaSiteId, origin) => {
  void biLogger.log({
    evid: BI_EVENTS.NOTIFICATION_SHOWN,
    msid: metaSiteId,
    platform: origin,
    new_notifications: count,
  });
});

const sendIconShownReport = once((metaSiteInstance, language) => {
  void reportEvent({
    type: REPORT_EVENTS.ICON_SHOWN,
    metaSiteInstance,
    language,
  });
});

export const getNotificationCount = ({
  metaSiteInstance,
  metaSiteId,
  origin,
  subjectNames,
  language,
}: {
  metaSiteInstance: string;
  metaSiteId: string;
  origin: string;
  subjectNames: string[];
  language?: string;
}): Promise<number> => {
  const subjectNamesQuery = arrayToQueryString('subjectNames', subjectNames);
  const headers = {
    Authorization: metaSiteInstance,
    wixLanguage: language,
    ...httpClientHeader,
  };

  return httpClient
    .get(`${API_URL}?type=UNSEEN&${subjectNamesQuery}`, {
      headers,
    })
    .then((response) => response.data)
    .then(({ count }) => {
      if (count) {
        sendNotificationShownBI(count, metaSiteId, origin);
      }

      // this report is required by server team
      sendIconShownReport(metaSiteInstance, language);

      return count;
    })
    .catch((e) => {
      throw new Error(`Failed to get count with error: ${e}`);
    });
};
